import * as Yup from 'yup'

// VAPT TRT-11: plain-text fields (names, titles) are reused on the public site in slugs, menus and
// meta tags, so markup must not get in. Mirrors the API's NoHtml rule: a markup check ("<" followed
// by a letter, "/", "!", "?" or ">") plus a character allowlist, so a lone "<" or ">" is rejected too.
export const safeText = (max = 250) =>
  Yup.string()
    .max(max, `Must be at most ${max} characters`)
    .test('no-html', 'Must not contain HTML tags', (v) => !v || !/<[a-zA-Z/!?>]/.test(v))
    .test(
      'allowed-chars',
      `Only letters, numbers, spaces and . , - ' & ( ) / : % ? ! " + । @ are allowed`,
      (v) => !v || /^[\p{L}\p{M}\p{N}\s.,\-'’&()/:%?!"+।@]*$/u.test(v)
    )
